import React from 'react';

import {
	ExperienceFailureTracker as ViewExperienceFailureTracker,
	ExperienceAbortTracker as ViewExperienceAbortTracker,
} from '@atlassian/jira-common-experience-tracking-viewing/src/view/experience-tracker-consumer/result-declared/index.tsx';
import {
	AUTHENTICATION_ERROR,
	CONNECTIVITY_ERROR,
	NOT_FOUND_OR_NO_PERMISSION_ERROR,
} from '@atlassian/jira-issue-shared-types/src/common/types/error-type.tsx';

import { AuthenticationErrorView } from '@atlassian/jira-issue-view-errors/src/ui/authentication-error-view/index.tsx';
import { UnknownErrorView } from '@atlassian/jira-issue-view-errors/src/ui/unknown-error-view/index.tsx';
import { type Props, FAILURE_TRACKER_TESTID, ABORT_TRACKER_TESTID } from './types.tsx';

const PermissionErrorView = importCond<
	typeof import('@atlassian/jira-issue-view-errors/src/ui/new-permission-error-view/index.tsx'),
	typeof import('@atlassian/jira-issue-view-errors/src/ui/permission-error-view/index.tsx')
>(
	'smart_access_unified_deadend',
	'@atlassian/jira-issue-view-errors/src/ui/new-permission-error-view/index.tsx',
	'@atlassian/jira-issue-view-errors/src/ui/permission-error-view/index.tsx',
);

const IssueErrorViewWithSuccessTrackingNew = ({
	errorType,
	loginRedirectUrl,
	errorAttributes,
}: Props): React.JSX.Element => {
	switch (errorType) {
		case AUTHENTICATION_ERROR:
			return (
				<ViewExperienceAbortTracker
					data-testid={ABORT_TRACKER_TESTID}
					location="auth-error"
					failureEventAttributes={errorAttributes}
				>
					<AuthenticationErrorView loginRedirectUrl={loginRedirectUrl} />
				</ViewExperienceAbortTracker>
			);
		case NOT_FOUND_OR_NO_PERMISSION_ERROR:
			return (
				<ViewExperienceAbortTracker
					data-testid={ABORT_TRACKER_TESTID}
					location="not-found-or-no-permission-error"
					failureEventAttributes={errorAttributes}
				>
					<PermissionErrorView />
				</ViewExperienceAbortTracker>
			);
		case CONNECTIVITY_ERROR:
			return (
				<ViewExperienceAbortTracker
					data-testid={ABORT_TRACKER_TESTID}
					location="connectivity-error"
					failureEventAttributes={errorAttributes}
				>
					<UnknownErrorView />
				</ViewExperienceAbortTracker>
			);
		default:
			return (
				<ViewExperienceFailureTracker
					data-testid={FAILURE_TRACKER_TESTID}
					location="unknown-error"
					failureEventAttributes={errorAttributes}
				>
					<UnknownErrorView />
				</ViewExperienceFailureTracker>
			);
	}
};

export default IssueErrorViewWithSuccessTrackingNew;
